import { useContext } from 'react';
import { createNamedContext } from '~/util';

export const OrderHistoryContext = createNamedContext('OrderHistoryContext');

export const useOrderHistory = () => useContext(OrderHistoryContext);